const solve_CN_Locale = {
    'solve.swiperCenter1': '全栈式智能超声解决方案',
    'solve.swiperCenter2': '超声影像AI部署平台NiCE',
    'solve.swiperName': '解决方案',
    'solve.title1':'全栈式智能超声解决方案',
    'solve.title2': '超声影像AI部署平台NiCE',
}
export default solve_CN_Locale
